import { render } from "./Internal.vue?vue&type=template&id=bb004b2e"
import script from "./Internal.vue?vue&type=script&lang=js"
export * from "./Internal.vue?vue&type=script&lang=js"

import exportComponent from "/home/stagingfloretcollegein/staging.floretcollege.in/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__